import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import i18n from '../../utils/i18n/i18n';
import Avatar from '../avatar/avatar';

const Review = styled.article`
  display: flex;
  gap: 12px;
  padding: 10px 0;
  color: var(--br-text);

  .review-content { min-width: 0; flex: 1; }
  .review-author { display: flex; align-items: baseline; gap: 8px; }
  .review-date { color: var(--br-muted); font-size: 0.85em; }
  .review-rating { color: #b77b19; white-space: nowrap; letter-spacing: 1px; }
`;

const Rating = ({ label, value }) => {
  const rating = Math.max(0, Math.min(5, Math.round(Number(value) || 0)));
  return (
    <span className="review-rating" role="img" aria-label={`${label}: ${rating} out of 5`}>
      {'★'.repeat(rating)}{'☆'.repeat(5 - rating)}
    </span>
  );
};

const ReviewItem = ({ reviewData }) => {
  const ratings = [
    [i18n.t('OverallRating'), reviewData.overAllRating ?? reviewData.avgOverAllRating],
    [i18n.t('PlotRating'), reviewData.plotRating ?? reviewData.avgPlotRating],
    [i18n.t('GrammarRating'), reviewData.grammarRating ?? reviewData.avgGrammarRating],
  ];

  return (
    <Review>
      {reviewData.displayName && <Avatar name={reviewData.displayName} />}
      <div className="review-content">
        {reviewData.displayName && (
          <div className="review-author">
            <strong>{reviewData.displayName}</strong>
            {reviewData.updatedAt && <time className="review-date" dateTime={new Date(reviewData.updatedAt).toISOString()}>
              {moment(new Date(reviewData.updatedAt)).fromNow()}
            </time>}
          </div>
        )}
        <table className="plain-table">
          <tbody>
            {ratings.map(([label, value]) => (
              <tr key={label}>
                <th scope="row">{label}:</th>
                <td><Rating label={label} value={value} /></td>
              </tr>
            ))}
            {reviewData.text && (
              <tr>
                <td colSpan={2}>
                  <div id={`${reviewData._id}_reviewtext`} style={{ whiteSpace: 'pre-wrap' }}>
                    {reviewData.text}
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </Review>
  );
};

export default ReviewItem;
